import { render, staticRenderFns } from "./ProjectCategories.vue?vue&type=template&id=4c46356b"
import script from "./ProjectCategories.ts?vue&type=script&lang=ts&external"
export * from "./ProjectCategories.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports